import Vue from 'vue';
import Router from 'vue-router';
import Report from '@/components/Report';

Vue.use(Router);

export default new Router({
  //mode: 'hash',
  routes: [
    {
      path: '/:ha',
      component: Report
    },
    {
      path: '*',
      component: Report,
      redirect: '/bc'
    }
  ]
  // routes: [
  //   {
  //     path: '*',
  //     component: Report,
  //     redirect: '/bc',
  //   },
  //   {
  //     path: '/bc',
  //     component: Report,
  //     props: {
  //       ha: 'bc',
  //     },
  //   },
  //   {
  //     path: '/fha',
  //     component: Report,
  //     props: {
  //       ha: 'fha',
  //     },
  //   },
  //   {
  //     path: '/iha',
  //     component: Report,
  //     props: {
  //       ha: 'iha',
  //     },
  //   },
  //   {
  //     path: '/nha',
  //     component: Report,
  //     props: {
  //       ha: 'nha',
  //     },
  //   },
  //   {
  //     path: '/vcha',
  //     component: Report,
  //     props: {
  //       ha: 'vcha',
  //     },
  //   },
  //   {
  //     path: '/viha',
  //     component: Report,
  //     props: {
  //       ha: 'viha',
  //     },
  //   },
  // ],
});



// WEBPACK FOOTER //
// ./src/web/router/index.js